import { Center } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useTitle } from 'react-use'
import { Container } from '../../common/components/Container'
import { TextLink } from '../../common/components/TextLink'
import { Title } from '../components/Title'

const RegistrationComplete: FC = () => {
  const [t] = useTranslation()
  useTitle(t('SEPAS 新規会員登録'))

  return (
    <Container innerWidth={'800px'}>
      <Title text={t('新規会員登録')} />
      <div className={'mt24'}>
        {t('新規会員登録が完了しました。')}
        <br />
        {t('トップページからログインしてください。')}
      </div>
      <div className={'mt24'}>
        <Center className={'mt8'}>
          <TextLink text={t('トップページへ戻る')} to={'/'} />
        </Center>
      </div>
    </Container>
  )
}

export default RegistrationComplete
